export const FILE_TYPE_PDF = 'application/pdf';
